var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCirclePause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#DB9A2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 7,
    width: 0.875,
    height: 6,
    rx: 0.4375,
    fill: "#DB9A2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.375,
    y: 7,
    width: 0.875,
    height: 6,
    rx: 0.4375,
    fill: "#DB9A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCirclePause);
export default __webpack_public_path__ + "static/media/progress-circle-pause.452b349779cab83ef69291871497f695.svg";
export { ForwardRef as ReactComponent };